








































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { addDays } from '@/helpers/dateUtils';
import * as service from '@/services/dashboard';
import { STATUS_PRESCRIPTION_LIST } from '@/settings/consts/prescription-status';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages,
    UiDatePicker,
  },
})
export default class StatusPrescriptionCharts extends BaseComponent {
  @Prop()
  public idsBusinessUnits: number[];

  date = new Date().toISOString();
  periodo = 'a';
  comValor = true;
  loading = false;
  error = false;

  public dataShow = [];
  public data = [];
  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.date = addDays(new Date(), 1).toISOString();
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.getStatusPrescriptionChartData(filter);
        }),
      )
      .subscribe(
        (res) => {
          this.data = res;
          this.loading = false;
          this.data.forEach((r) => {
            r.status = STATUS_PRESCRIPTION_LIST.filter((i) => i.key == r.id)[0];
          });
          this.onChangeComValor(this.comValor);
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );

    this.prepareLoad();
  }

  buildTimeout = null;

  load() {
    let filtro = this.buildFiltro();
    this.execBehaviorSub$.next(filtro);
  }

  buildFiltro() {
    let filtro: any = {};
    filtro.dataDe = this.date ? dateFormat(this.date, 'US') : null;
    filtro.dataAte = this.date ? dateFormat(this.date, 'US') : null;
    filtro.idsEmpresas = this.idsBusinessUnits;

    return filtro;
  }

  @Watch('date')
  @Watch('idsBusinessUnits')
  public onChangeDates() {
    this.prepareLoad();
  }

  timeoutDatesChange = null;
  public prepareLoad() {
    clearTimeout(this.timeoutDatesChange);
    this.timeoutDatesChange = setTimeout(() => {
      this.load();
    }, 100);
  }

  @Watch('comValor')
  public onChangeComValor(v) {
    if (v) {
      this.dataShow = this.data.filter((i) => i.valor > 0);
    } else {
      this.dataShow = this.data;
    }
  }
}
